export const API = {
  BASE_URL: {
    STUDIO:
      "https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    LOGIN: "https://azuq6zfu0l.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    FEEDBACK:
      "https://45nqltb6r4.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    DASHBOARD:
      " https://re9q02gew0.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    TRAINING:
      "https://e6ajh3xbob.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
    TRAINING_EXTEND:
      "https://l57wedfp5m.execute-api.ap-south-1.amazonaws.com/dev/api/v1",
  },
  END_POINTS: {
    LOGIN_ENDPOINT: "/users/signIn",
    LOGOUT: "/users/logout",
    TRAININGCENTER_ENDPOINT: "/studios",
    TRAININGCENTER_UPDATE: "/studios/update",
    CREATE_FEEDBACK: "/feedback-template/add",
    STUDIO_LIST: "/allstudios",
    ADD_TEMPLATE_ADMIN: "/feedback-template/add",
    FEEDBACK_STUDIO_ADMIN: "/studio/feedback-template/add",
    FEEDBACK_INSTRUCTOR: "/instructor/feedback-template/add",
    SAVE_FEEDBACK: "/save-feedback-response",
    GET_FEEDBACK_QUESTION: "/feedback-questions",
    ADMIN_DASHBOARD: "/dashboard/superAdmin",
    GET_TRAINING_LISTING: "/training",
    USERS: "/users",
    STUD_ADMIN: "/studadmin/users",
    UPDATE_TRAINING: "/updateTraining",
    TRAINING_STUDIO_ADMIN_UPDATE: "/studioadmin/training/update",
    TRAINING_INSTRUCTOR_UPDATE: "/instructor/training",
    TRAINING_INSTRUCTOR: "/instructor/training",
    GET_STUDENT_TRAINING_LISTING: "/training/student",
    VIEW_INSTRUCTOR: "/users_byid",
    GET_LOCATION: "/locations",
    GET_AWS_REGION: "/region",
    STUDIO_ADMIN: "/users/studadmin",
    DASHBOARD_GRAPH: "/dashboard/graph",
    DASHBOARD_SESSION_GRAPH: "/dashboard/dashboardcount",
    GETDELETEDNSRECORD: "/support/showDNSRecords",
    DELETEDNSRECORDS: "/support/deleteDNSRecords",
    GETISSUEVMS: "/support/sendTrainingIdResponseForWeek",
    S3BUCKET_PRESIGNED_URL: "/getS3Url",
    TRAINING: "/training",
    FAILEDTRAINING: "/support/failed-training-ids",
    FAILEDTRAININGDETAILS: "/support/sendFailedTrainingIdDetails",
    RELAUNCHFAILEDINSTANCE: "/support/relaunch-failed-instance",
    STOPFAILEDINSTANCE: "/support/stopping-failed-instance",
    FEEDBACK_TRAINING: "/list/training",
    GET_FEEDBACK_INSTRUCTOR: "/training/instructor/feedback-list",
    GET_FEEDBACK_LIST: "/training/feedback-list",
    FEEDBACK_RESPONSE: "/view-feedback-response",
    GET_EXPORTVIEWFEEDBACK: "/training/instructor/feedback",
    CALENDER: "/training/getInstructorCalender",
    CALENDERID: "/training/dates",
    VEYON_MULITFEED: "/multiFeedToken",
    VEYON_SINGLEFEED: "/singleFeedToken",
    RESET_PASSWORD: "/users/resetVMPassword",
    STARTSERVER: "/users/startServer",
    STOPSERVER: "/users/stopServer",
    IMAGECONFIGURATOR_LIST: "/getImage",
    CREATE_IMAGE: "/createImage",
    TEST_IMAGE: "/testImage",
    IMAGE_STATUS: "/imageStatus",
    EMAIL_TEMPLATE: "/users/createEmailTemplate",
    VEYON_IMAGE_SINGLEFEED: "/singleFeed",
    VEYON_IMAGE_MULTIFEED: "/multiFeed",
    EMAIL_TEMPLATE_LISTING: "/users/listEmailTemplate",
    CANCELLED_TRAINING: "/training/delete",
    GET_IMAGE_BY_ID: "/getImageByID",
    CONFIRM_IMAGE: "/imageToDashboard",
    TRAININGDELETE_ENDPOINT: "/studios",
    FEEDBACK_DATA: "/feedback-template",
    TRAININGCENTERMASTER_ENDPOINT: "/masters/studios_admin",
    INSTRUCTOR_ENDPOINT: "/users/instructorMaster",
    STUDENT_ENDPOINT: "/student_master",
    TCADMIN_ENDPOINT: "/getTCAdmin",
    AMI_LISTING: "/region/ami",
    INSTANCE_LISTING: "/getInstanceType",
    AUTO_ASSIGN: "/training/auto-assign",
    DELETETCADMIN: "/deleteTCAdmin",
    TRAINING_BY_ID: "/trainingById",
    RESCHEDULE: "/training/reschedule_training",
    TC_BYID: "/getTCAdminById",
    ADD_TCADMIN: "/addTCAdmin",
    UPDATE_TCADMIN: "/updateTCAdmin",
    ADMIN_TEMPLATE_DELETE: "/admin/feedback-template/delete",
    STUDIO_TEMPLATE_DELETE: "/studio/feedback-template/delete",
    INSTRUCTOR_TEMPLATE_DELETE: "/instructor/feedback-template/delete",
    STUDIOADMIN_INSTRUCTOR_ENDPOINT: "/users/studadmin/instructorMaster",
    USER_EPIC_LOGIN: "/users/signEpicIn",
    STUDENT_EPIC_LOGIN: "/student/signEpicIn",
    STUDENT_USER_DELETE: "/student",
    IS_MACHINE_REQUIRED: "/training/accept/is-machine-required",
    EXTEND_SERVER: "/training/extendServer",
    GET_VM_REPORT: "/report",
    TRAINING_INSTRUCTOR: "/instructor/training/create",
    TRAINING_STUDIO_ADMIN: "/studioadmin/training",
    STUDENTBYID: "/studentById",
    PROJECTCONFIRM: "/addProject",
    EMAIL_LIST: "/emailTemplateList",
    EMAIL_TEMPLATE_DELETE: "/users/deleteEmailTemplate",
    GET_EMAIL_BY_ID: "/users/emailTemplateByID",
  },
};
/* ROUTES STARTS */
export const APP_ROUTES = {
  ROUTE_ROOT: "/dashboard",
  ERROR: "*",
  ROUTE_LOGIN: "/",
  ROUTE_ADMIN_LOGIN: "/admin/login",
  ROUTE_IMAGECONFIGURATOR: "/admin/imageconfigurator",
  ROUTE_CREATESESSION: "/createsession",
  ROUTE_EMAILTEMPLATE: "/emailtemplate",
  ROUTE_EMAILTEMPLATELIST: "/emailtemplatelist",
  ADD_INSTRUCTOR: "/addinstructor",
  VEYON: "/veyon",
  ADD_TRAINING_CENTRE: "/addcentre",
  LONGTERMMACHINE: "/longterm",
  MONITORING: "/monitoring",
  TRAINING_LISTING: "/training",
  TRAINING_LISTING_DETAILS: "/training_details",
  FEEDBACK_LISTING: "/feedback",
  FEEDBACK_LISTING_DETAILS: "/feedback_details",
  FEEDBACK_CHART: "/feedback_chart",
  CREATE_FEEDBACK: "/createfeedback",
  ROUTE_TRAININGCENTER: "/training-center",
  ROUTE_STUDENT: "/student",
  ROUTE_INSTRUCTOR: "/instructor",
  ROUTE_TRAININGCENTER_ADMIN: "/tc_admin",
  FILL_FEEDBACK: "/submit-feedback",
  CALENDER: "/calender",
  ADD_TC_ADMIN: "/addtcadmin",
  FEEDBACK_TEMPLATE_LISTING: "/feedbacktemplate",
  CALLBACK: "/callback",
  ADD_STUDENT: "/addStudent",
  REPORTS: "/reports",
  CONTACTSUPPORT: "/contactSupport",
};
/* ROUTES ENDS */

export const FOMRS = {
  ADD: "ADD",
  EDIT: "EDIT",
  VIEW: "VIEW",
};
export const FORM_VALIDATION = {
  EMIAL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-ZÀ-žäöüÄÖÜß\-0-9]+\.)+[a-zA-ZÀ-žäöüÄÖÜß]{2,}))$/,
  SKILLS: /^(?=[a-zA-Z0-9~@#$&^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/,
  SCRIPT:
    /^(?=[a-zA-ZÀ-žäöüÄÖÜß0-9~@#$&\n^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/,
  SCRIPT2: /^(?=[a-zA-ZÀ-žäöüÄÖÜß0-9~@#$&\n/;`%()_+=[\]{}|\\,.?: -]*$)/,
  NAME: /^(?=[a-zA-ZÀ-žäöüÄÖÜß0-9~@#$&^*/;`%()_+=[\]{}|\\,.?: -]*$)(?!._*[<>'"])/,
  IMAGE_NAME:
    /^(?=[a-zA-ZÀ-žäöüÄÖÜß0-9~@#$&^*/;`%()+=[\]{}|\\,.?: -]*$)(?!.*[<>'"])/,
  CONTACT_NUMBER: /^(?=[a-zA-Z0-9~@#$^*()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"/;`%])/,
  VERSION: /[a-zA-Z]{1}\d{1,2}\.\d{1,2}\.\d{1,3}/,
  URL: /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
  BOX_LINK: /(https?:\/\/)?(www\.)?[a-z0-9-]+\.(box)(\.[a-z]{2,3})?/,
  IMAGE_NAME: /^[-_A-Za-z-0-9][-_A-Za-z0-9 ]{1,126}[-_A-Za-z-0-9]$/,
};
export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export const isEmpty = (value) => {
  if (value === null || value === "" || value === undefined) {
    console.log("return true");
    return true;
  } else {
    return false;
  }
};
export const ROLE = {
  ADMIN: "SUPER_ADMIN",
  STUDIO_ADMIN: "STUDIO_ADMIN",
  STUDENT: "STUDENT",
  INSTRUCTOR: "INSTRUCTOR",
};

export const AUTH_ROUTES = [APP_ROUTES.ROUTE_LOGIN, APP_ROUTES.ROUTE_LOGOUT];

export const CUSTOM_EVENT_TYPES = {
  CHAT_RECIEVED: "chat-recieved",
  CHAT_SENT: "chat-sent",
  SCROLL_END: "scroll-end",
};

export const STATUS = {
  OK: 200,
  CREATED: 201,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  DATA_NOT_FOUND: 404,
  DUPLICATE_RECORD: 409,
  INTERNAL_SERVER_ERROR: 500,
  NOT_APPLICABLE: 406,
  BAD_REQUEST: 400,
  UNPROCESSABLE_ENTITY: 422,
};

export const CONSTANTS_DATA = {
  CANCLE: "cancle",
  PENDING: "pending",
  COMPLETED: "completed",
  DEFAULT: "Default",
  INTERESTED: "Interested",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
};
